module.exports = __webpack_public_path__ + "img/ctb.6e70b7a1.png";